<div
  class="box__inner box--{{ highlight }} box-highlight--{{
    highlight ? highlightPosition : 'none'
  }} box--rounded-{{ borderRadius }}"
  [ngClass]="{ 'box--selectable': selectable, 'box--selected': selected }"
>
  <ng-content></ng-content>
</div>
